<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .tab {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;

    gap: utils.in_rem(16px);
  }
</style>

<script>
  import TabPanel from "@sourcewhale/shared/svelte-design-system/components/molecules/TabPanel.svelte";
  import About from "./About/About.svelte";
  import Funding from "./Funding/Funding.svelte";
  import Header from "./Header.svelte";
  import Jobs from "./Jobs/Jobs.svelte";
  import News from "./News/News.svelte";

  import { companyInsightsOptsStore, companyInsightsTabs } from "./stores";

  export let isTabOpen = false;
  export let obj;
  export let origin;

  $: companyInsightsOptsStore.set({ isTabOpen, obj, origin });

  const getSnippetForTab = (slot) => {
    switch (slot) {
      case "tab0":
        return aboutSnippet;
      case "tab1":
        return newsSnippet;
      case "tab2":
        return jobsSnippet;
      case "tab3":
        return fundingSnippet;
      default:
        return null;
    }
  };

  const tabItems = companyInsightsTabs.map((tab) => ({
    ...tab,
    snippet: getSnippetForTab(tab.slot),
  }));
</script>

{#snippet aboutSnippet()}
  <About />
{/snippet}

{#snippet newsSnippet()}
  <News />
{/snippet}

{#snippet jobsSnippet()}
  <Jobs />
{/snippet}

{#snippet fundingSnippet()}
  <Funding />
{/snippet}

<div class="tab">
  <Header />
  <TabPanel
    class="flex-1"
    {tabItems}
    type="secondary-pill"
    size="small"
    style="position: relative;"
  />
</div>
